var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_21714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3118 52.7994C41.8919 52.7994 53.7115 40.9798 53.7115 26.3997C53.7115 11.8195 41.8919 0 27.3118 0C12.7316 0 0.912109 11.8195 0.912109 26.3997C0.912109 40.9798 12.7316 52.7994 27.3118 52.7994Z",
    fill: "url(#paint0_linear_1197_21714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4812 13.7689C41.5336 13.3582 42.6216 14.2791 42.3905 15.3848L37.6705 37.9463C37.45 39.0041 36.2074 39.4805 35.3363 38.8405L28.2111 33.6104L24.5792 37.3188C23.9409 37.9695 22.8405 37.7046 22.5667 36.837L19.9463 28.5189L12.9224 26.4442C11.9997 26.1722 11.9464 24.8887 12.8406 24.5385L40.4812 13.7689ZM37.0163 18.775C37.3238 18.503 36.9665 18.023 36.618 18.2399L21.4573 27.6424C21.1906 27.8077 21.068 28.1331 21.1622 28.4335L23.2297 37.5125C23.2706 37.6512 23.4697 37.6316 23.4875 37.4876L23.9497 30.5686C23.9674 30.398 24.0492 30.2415 24.1773 30.1278L37.0163 18.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6201 18.24C36.9685 18.0231 37.3259 18.5031 37.0184 18.7751L24.1794 30.1279C24.0515 30.2416 23.9697 30.3981 23.9519 30.5687L23.4897 37.4877C23.4719 37.6317 23.2728 37.6513 23.2318 37.5126L21.1643 28.4336C21.0701 28.1332 21.1928 27.8078 21.4595 27.6425L36.6201 18.24Z",
    fill: "#9EC2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3044 37.6071C22.9702 37.488 22.6876 37.2213 22.5667 36.8373L19.9463 28.5191L12.9224 26.4445C11.9997 26.1725 11.9464 24.889 12.8406 24.5388L40.4811 13.7692C41.1601 13.5043 41.8553 13.7941 42.1984 14.3311C42.1343 14.2333 42.0579 14.1427 41.9726 14.0626L23.2208 29.3708V30.041L23.1177 29.9664L23.2208 34.1868V37.5717C23.2475 37.5841 23.2759 37.5948 23.3043 37.6036V37.6071H23.3044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2147 33.6104L24.5828 37.3188C24.5525 37.349 24.5206 37.3793 24.4885 37.406C24.4565 37.4327 24.4245 37.4558 24.3907 37.4789C24.389 37.4806 24.389 37.4806 24.389 37.4806C24.3214 37.5251 24.2521 37.5624 24.1792 37.5926C24.1419 37.6069 24.1063 37.6211 24.069 37.63C23.9143 37.6762 23.7561 37.6886 23.5997 37.6726C23.5588 37.6691 23.5179 37.662 23.4788 37.6549C23.4734 37.6549 23.4682 37.6532 23.4628 37.6514C23.4237 37.6408 23.3846 37.6301 23.3455 37.6176C23.333 37.6141 23.3206 37.6105 23.3081 37.6034L23.2246 34.1866V30.0408L28.2147 33.6104Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4861 37.406C24.4536 37.4332 24.421 37.4584 24.3867 37.4819V37.4801C24.4211 37.4566 24.4536 37.4332 24.4861 37.406Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3909 37.479V37.4832C24.3909 37.4832 24.3909 37.479 24.3867 37.4832C24.3867 37.4832 24.3867 37.4832 24.3909 37.479Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1758 37.5931C24.2489 37.5628 24.3185 37.5253 24.3863 37.4807C24.3185 37.5252 24.2471 37.5627 24.1758 37.5931Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5957 37.673C23.7521 37.6891 23.9103 37.6765 24.065 37.6299C23.953 37.6658 23.8374 37.6819 23.7219 37.6819C23.6863 37.6819 23.6508 37.6801 23.617 37.6765C23.6099 37.6766 23.6028 37.6766 23.5957 37.673Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6015 37.6725C23.6087 37.6761 23.6159 37.6761 23.623 37.6761C23.5854 37.6743 23.5514 37.6689 23.5156 37.6616C23.5442 37.6672 23.5729 37.6707 23.6015 37.6725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5983 37.6733C23.5696 37.6715 23.541 37.6679 23.5124 37.6625C23.4998 37.6607 23.4874 37.6589 23.4766 37.6553C23.5159 37.6625 23.5571 37.6697 23.5983 37.6733Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 37.6177C23.3831 37.6304 23.4226 37.6412 23.462 37.6521C23.4459 37.6485 23.4298 37.6448 23.4137 37.6413C23.4065 37.6395 23.3993 37.6377 23.3939 37.634C23.3777 37.6304 23.3599 37.6249 23.3438 37.6177Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4141 37.6404C23.4303 37.6439 23.4466 37.6476 23.4628 37.6512C23.4466 37.6494 23.4303 37.6458 23.4141 37.6404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3455 37.6178C23.3619 37.6251 23.3802 37.6306 23.3967 37.6342C23.3692 37.6287 23.3419 37.6196 23.3145 37.6086C23.3254 37.6122 23.3345 37.616 23.3455 37.6178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3466 37.6186C23.3352 37.6167 23.3256 37.6129 23.3142 37.6091C23.3124 37.611 23.3085 37.6091 23.3066 37.6073V37.6035C23.3199 37.611 23.3332 37.6148 23.3466 37.6186Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2246 34.1865L23.3089 37.6033C23.2802 37.5945 23.2515 37.5837 23.2246 37.5714V34.1865Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2213 30.0407V34.1865L23.1172 29.9661L23.2213 30.0407Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0184 18.775L24.1794 30.1278C24.0515 30.2416 23.9697 30.398 23.9519 30.5687L23.4905 37.4883C23.4727 37.6322 23.2736 37.6518 23.2309 37.5131L21.1643 28.4336C21.0701 28.1332 21.1928 27.8078 21.4595 27.6425L36.6202 18.24C36.9686 18.0231 37.326 18.5031 37.0184 18.775Z",
    fill: "#ADBCC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_21714",
    x1: 27.3118,
    y1: 0,
    x2: 27.3118,
    y2: 52.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_21714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7994,
    height: 52.7994,
    fill: "white",
    transform: "translate(0.912109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.353a82565203f7e95ffc71ee27ae46fc.svg";
export { ForwardRef as ReactComponent };